// Browser clocks can be wrong by minutes or hours. When the server tells us
// "now" alongside a server-issued timestamp, we capture the offset between
// server and browser at that moment so later UI can render server-relative
// elapsed time without trusting the local clock.

export function computeClockSkewMs(
  serverTimeIso: string | null | undefined
): number {
  if (!serverTimeIso) return 0;
  const serverMs = new Date(serverTimeIso).getTime();
  if (Number.isNaN(serverMs)) return 0;
  return serverMs - Date.now();
}

export function elapsedMsSince(
  startIso: string | null | undefined,
  clockSkewMs: number
): number {
  if (!startIso) return 0;
  const startMs = new Date(startIso).getTime();
  if (Number.isNaN(startMs)) return 0;
  return Math.max(0, Date.now() + clockSkewMs - startMs);
}
